// let s = 'http://127.0.0.1:8081/'
var isLocal = window.location.hostname == 'localhost' ||
    window.location.hostname == '192.168.1.130';
// const s = 'https://f01ac64d-4db3-4c7a-88fa-97f374b7c166.pub.instances.scw.cloud/exporter/'
// const s =  'http://127.0.0.1:8081/'
// const s = "/exporter/"
var s = "https://airbacus.org/exporter/";
var server = isLocal ? s : '/exporter/';
var spinner = "<div class=\"aqspinner3\"><div class=\"r1\"></div><div class=\"r2\"></div><div class=\"r3\"></div><div class=\"r4\"></div><div class=\"r5\"></div></div>";
export { server, spinner, isLocal };
